import { defineStyleConfig } from "@chakra-ui/styled-system";

export default defineStyleConfig({
  baseStyle: {
    color: "pairs.gray.900",
  },
});
